import { Clock, CheckCircle, XCircle, Eye, RotateCcw } from 'lucide-react';

export const ResultScreen1 = ({ results, timer, relatedArticles, viewSolutions, resetTest }) => {
  const styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      padding: '32px',
      textAlign: 'center'
    },
    title: {
      fontSize: '36px',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '16px'
    },
    button: {
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      padding: '12px 32px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '16px',
      transition: 'background-color 0.2s'
    },
    buttonHover: {
      backgroundColor: '#1d4ed8'
    },
    buttonSecondary: {
      backgroundColor: '#4b5563',
      color: 'white'
    },
    buttonSecondaryHover: {
      backgroundColor: '#374151'
    },
    resultCard: {
      backgroundColor: '#f0fdf4',
      padding: '24px',
      borderRadius: '8px',
      marginBottom: '16px',
      textAlign: 'center'
    },
    resultCardError: {
      backgroundColor: '#fef2f2'
    },
    resultCardInfo: {
      backgroundColor: '#eff6ff'
    },
    resultValue: {
      fontSize: '24px',
      fontWeight: '700',
      marginBottom: '8px'
    }
  };

  console.log('resultsss',results)
  console.log('timer',timer)
  console.log('viewSolutions',viewSolutions)
  const percentage = Math.round((results.correct / results.total) * 100);
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div style={{ maxWidth: '896px', margin: '0 auto' }}>
      <div style={styles.card}>
        <h1 style={styles.title}>Test Results</h1>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr', 
          gap: '24px', 
          marginBottom: '32px',
          '@media (min-width: 768px)': {
            gridTemplateColumns: 'repeat(3, 1fr)'
          }
        }}>
          <div style={styles.resultCard}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
              <CheckCircle style={{ width: '48px', height: '48px', color: '#16a34a' }} />
            </div>
            <h3 style={styles.resultValue}>{results.correct}</h3>
            <p style={{ color: '#4b5563' }}>Correct Answers</p>
          </div>
          
          <div style={{ ...styles.resultCard, ...styles.resultCardError }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
              <XCircle style={{ width: '48px', height: '48px', color: '#dc2626' }} />
            </div>
            <h3 style={styles.resultValue}>{results.attempted - results.correct}</h3>
            <p style={{ color: '#4b5563' }}>Wrong Answers</p>
          </div>
          
          <div style={{ ...styles.resultCard, ...styles.resultCardInfo }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
              <Clock style={{ width: '48px', height: '48px', color: '#2563eb' }} />
            </div>
            <h3 style={styles.resultValue}>{formatTime(Math.floor(timer))}</h3>
            <p style={{ color: '#4b5563' }}>Total Time</p>
          </div>
        </div>
        
        <div style={{ marginBottom: '32px' }}>
          <div style={{ fontSize: '36px', fontWeight: '700', color: '#1f2937', marginBottom: '8px' }}>{percentage}%</div>
          <div style={{ fontSize: '18px', color: '#4b5563' }}>Overall Score</div>
          <div style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            marginTop: '8px',
            color: percentage >= 60 ? '#16a34a' : '#dc2626'
          }}>
            {percentage >= 60 ? 'Great Job! You\'re ready!' : 'Keep practicing to improve!'}
          </div>
        </div>
        
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '16px',
          '@media (min-width: 640px)': {
            flexDirection: 'row',
            justifyContent: 'center'
          }
        }}>
          <button
            onClick={viewSolutions}
            style={{
              ...styles.button,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.button.backgroundColor}
          >
            <Eye style={{ width: '20px', height: '20px' }} />
            View Solutions
          </button>
          
          <button
            onClick={resetTest}
            style={{
              ...styles.button,
              ...styles.buttonSecondary,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.buttonSecondary.backgroundColor}
          >
            <RotateCcw style={{ width: '20px', height: '20px' }} />
            Retake Test
          </button>
        </div>
      </div>
    </div>
  );
};